import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import bitmapFonts from 'src/lib/bitmapFonts';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

type CardsEmptyMessageOpts = ViewOpts & {
  localeText: () => string;
};

export class CardsEmptyMessage extends View {
  constructor(opts: CardsEmptyMessageOpts) {
    const { localeText, ...viewOpts } = opts;
    super({
      tag: 'cards-empty-message',
      width: opts.superview?.style.width ?? 582,
      height: opts.superview?.style.height ?? 720,
      ...viewOpts,
    });

    new ImageScaleView({
      tag: 'empty-pet',
      superview: this,
      image: 'assets/ui/cards/common/sad_pet.png',
      scaleMethod: 'contain',
      x: this.style.width * 0.5,
      y: 260,
      width: downscale(267),
      height: downscale(270),
      centerOnOrigin: true,
    });

    new LangBitmapFontTextView({
      tag: 'empty-message',
      superview: this,
      align: 'center',
      verticalAlign: 'center',
      color: '#BF7B3E',
      wordWrap: true,
      x: 50,
      y: 345,
      size: 28,
      width: this.style.width - 100,
      height: 100,
      font: bitmapFonts('Body'),
      leading: -14,
      localeText,
    });

    new ImageScaleView({
      tag: 'empty-arrow',
      superview: this,
      image: 'assets/ui/cards/common/long_arrow.png',
      scaleMethod: 'contain',
      x: this.style.width * 0.5,
      y: 515,
      width: downscale(35),
      height: downscale(200),
      centerOnOrigin: true,
    });
  }
}
